module.exports = __webpack_public_path__ + "static/media/hero-subsection-background.1fe30ec9.svg";